import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, BarChart3, Trophy, Heart, Settings } from "lucide-react";

const TABS = [
  { id: "mejoras", label: "Upgrades", shortLabel: "Upgrades", Icon: TrendingUp },
  { id: "stats", label: "Statistics", shortLabel: "Stats", Icon: BarChart3 },
  { id: "logros", label: "Achievements", shortLabel: "Achievements", Icon: Trophy },
  { id: "donaciones", label: "Donations", shortLabel: "Donate", Icon: Heart },
  { id: "config", label: "Settings", shortLabel: "Settings", Icon: Settings },
];

// Fixed bottom navigation bar. Each tab calls the corresponding handler.
// The `activeId` prop drives the yellow-highlighted state.
export const BottomNav = ({ activeId = "mejoras", onSelect }) => {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-20 flex items-stretch"
      style={{
        backgroundColor: "#0a0a0a",
        borderTop: "1px solid #1c1c1c",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="bottom-nav"
    >
      {TABS.map((t) => {
        const isActive = t.id === activeId;
        const { Icon } = t;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onSelect?.(t.id)}
            data-testid={`bottom-nav-${t.id}`}
            className="flex-1 flex flex-col items-center justify-center gap-1 py-2.5 sm:py-3 relative group min-w-0"
            style={{
              backgroundColor: isActive ? "#FFD400" : "transparent",
              color: isActive ? "#111" : "#8a8a8a",
              transitionProperty: "background-color, color",
              transitionDuration: "200ms",
            }}
          >
            {isActive && (
              <motion.span
                layoutId="nav-underline"
                aria-hidden
                className="absolute top-0 left-0 right-0 h-0.5"
                style={{ backgroundColor: "#111" }}
              />
            )}
            <Icon size={18} />
            <span
              className="text-[9px] sm:text-[10px] uppercase tracking-[0.15em] sm:tracking-[0.2em] font-bold truncate max-w-full px-0.5 sm:hidden"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              {t.shortLabel}
            </span>
            <span
              className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] font-bold truncate max-w-full px-0.5"
              style={{ fontFamily: "Orbitron, sans-serif" }}
            >
              {t.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
